import AuthLayout from '../layouts/AuthLayout.vue'
import { RouteRecordRaw } from 'vue-router'

export const publicRoutes: Array<RouteRecordRaw> = [
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        meta: {
          title: 'Login',
        },
        component: () => import('../pages/auth/Login.vue'),
      },
      // {
      //   name: 'recover-password',
      //   path: 'recover-password',
      //   component: () => import('../pages/auth/RecoverPassword.vue'),
      // },
      // {
      //   name: 'recover-password-email',
      //   path: 'recover-password-email',
      //   component: () => import('../pages/auth/CheckTheEmail.vue'),
      // },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
]

export const publicRouteNames = ['login']
